module.exports = "/_next/static/images/SolarEnergySolutions-d596afc55acb1785d97a6c99fbd13e05.webp";